export enum WhatsappCampaignStatus {
    'Pending'   = 0,
    'Completed' = 1,
    'Failed'    = 2
}